import { render, staticRenderFns } from "./AddMenuPage.vue?vue&type=template&id=0b12c0a1"
import script from "./AddMenuPage.vue?vue&type=script&lang=js"
export * from "./AddMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports